import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../StudentDashboard/Sidebar";
import Header from "../StudentDashboard/Headers";
import { API_URL } from "../../config/api";
import { Outlet } from "react-router-dom";

const Parent = () => {
  const [userData, setUserData] = useState(null);
  const [programsData, setProgramsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) {
          console.error("No access token found");
          setLoading(false);
          return;
        }

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // 1️⃣ Fetch current user → gives user_id
        const currentUser = await axios.get(`${API_URL}/current_user`, { headers });
        const userId = currentUser.data.user_id;
        if (!userId) {
          console.error("❌ user_id missing from /current_user response");
          setLoading(false);
          return;
        }

        // 2️⃣ Fetch full user profile + programs in parallel
        const [userDetailRes, programsRes] = await Promise.all([
          axios.get(`${API_URL}/user/${userId}`, { headers }),
          axios.get(`${API_URL}/courses/programs`, { headers }),
        ]);

        setUserData(userDetailRes.data.data);
        setProgramsData(programsRes.data);
      } catch (error) {
        console.error("❌ Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  const refetchUserData = async () => {
    try {
      const token = localStorage.getItem("access_token");
      if (!token) return;

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const currentUser = await axios.get(`${API_URL}/current_user`, { headers });
      const userId = currentUser.data.user_id;
      if (!userId) return;

      const userDetailRes = await axios.get(`${API_URL}/user/${userId}`, { headers });
      setUserData(userDetailRes.data.data);
    } catch (error) {
      console.error("❌ Error refetching user:", error);
    }
  };

  const refetchPrograms = async () => {
    try {
      const token = localStorage.getItem("access_token");
      if (!token) return;

      const res = await axios.get(`${API_URL}/programs`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setProgramsData(res.data);
    } catch (error) {
      console.error("❌ Error refetching programs:", error);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4AACC5] mx-auto"></div>
        </div>
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-600">
        Unable to load user data. Please log in again.
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
      <div className="flex-shrink-0">
        <Header userData={userData} />
      </div>

      <div className="flex flex-1 overflow-hidden">
        <div className="w-56 bg-white border-r border-neutral-200 flex-shrink-0">
          <Sidebar />
        </div>

        <div className="flex-1 p-4 overflow-y-auto">
          <Outlet context={{ userData, refetchUserData, programsData, refetchPrograms }} />
        </div>
      </div>
    </div>
  );
};

export default Parent;